import { usePendingCostEstimates } from './use-run-ledger';
import { useRunsStatusCounts } from './use-runs-list';

/** Unfiltered counts — one shared, cached read with the section header. */
const NO_FILTERS = {};

/**
 * How many batches wait on the current user: open gates (`awaitingGate`) plus cost approvals they
 * can decide. A cost-gated batch stays RUNNING server-side, so the two never overlap. When the
 * cost read fails the gate count stands alone; `undefined` until the gate count has loaded.
 */
export function useNeedsYouCount(): number | undefined {
  const counts = useRunsStatusCounts(NO_FILTERS).data;
  const pendingCost = usePendingCostEstimates().data ?? [];
  if (!counts) return undefined;
  return counts.awaitingGate + pendingCost.filter((estimate) => estimate.canDecide).length;
}
